class Blob {
  constructor() {
    this.blob = document.getElementById('cursor-gradient-blob');
    
    if (!this.blob || matchMedia('(pointer: coarse)').matches) {
      if (this.blob) this.blob.style.display = 'none';
      return;
    }

    // Coordinate attuali del blob
    this.pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    // Coordinate di destinazione (il mouse)
    this.mouse = { x: this.pos.x, y: this.pos.y };

    this.init();
  }

  init() {
    window.addEventListener('mousemove', (e) => {
      this.mouse.x = e.clientX;
      this.mouse.y = e.clientY;
    });

    // Avvia il loop di animazione
    this.render();
  }

  render() {
    // 1. Interpolazione (Lerp): fa avvicinare dolcemente il blob al mouse
    // Modifica '0.15' per renderlo più reattivo (es. 0.3) o più "pigro" (es. 0.05)
    this.pos.x += (this.mouse.x - this.pos.x) * 0.15;
    this.pos.y += (this.mouse.y - this.pos.y) * 0.15;

    // 2. Calcola la velocità (la differenza tra dove sta andando e dov'è)
    const velX = this.mouse.x - this.pos.x;
    const velY = this.mouse.y - this.pos.y;
    
    // 3. Calcola la velocità totale per definire l'allungamento
    const speed = Math.sqrt(velX * velX + velY * velY);
    
    // Clamp dell'allungamento massimo per evitare che diventi una linea sottilissima
    const scaleY = 1 + Math.min(speed * 0.004, 0.4); // Si allunga lungo la direzione
    const scaleX = 1 - Math.min(speed * 0.001, 0.1); // Si schiaccia leggermente sui lati

    // 4. Calcola l'angolo in cui si sta muovendo per ruotare il div
    const angle = Math.atan2(velY, velX) * (180 / Math.PI);

    // 5. Applica tutte le trasformazioni insieme
    this.blob.style.transform = `
      translate(calc(${this.pos.x}px - 50%), calc(${this.pos.y}px - 50%))
      rotate(${angle}deg)
      scale(${scaleY}, ${scaleX})
    `;

    // Richiama la funzione al prossimo frame
    requestAnimationFrame(() => this.render());
  }
}

export default Blob;